import Dialog from "./components/Dialog";
import Button from "../miscellaneous/Button";
import { formatDate } from "../../utils/Utils";
import { ButtonTheme } from "../miscellaneous/ButtonTheme";

export interface DrawPosponedDialogProps {
  onClose: () => void;
  newDate?: Date;
}

export default function DrawPostponedDialog(props: DrawPosponedDialogProps) {
  return (
    <Dialog onClose={props.onClose}>
      <div className="flex flex-col items-center ~px-10/8">
        <span className="text-center ~text-lg/xxl ~leading-5/6 font-barlowc font-bold text-silver ~mb-6/8">
          DRAW POSTPONED
        </span>
        <div className="text-base font-poppins text-silver text-center ~mb-2/4">
          {/* Due to unforeseen circumstances, */}
          No tickets were bought, so this game
          <br />
          has been postponed to <b>{formatDate(props.newDate)}</b>.
        </div>
        {/* <div className="text-base font-poppins text-silver text-center ~mb-6/8">
          We are deeply sorry for any
          <br />
          inconvenience this may have caused.
        </div> */}
        <div className="">
          <Button
            text={"CLOSE"}
            enabled={true}
            loading={false}
            theme={ButtonTheme.PersianPink}
            onClick={props.onClose}
          ></Button>
        </div>
      </div>
    </Dialog>
  );
}
